import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { token } from '@atlaskit/tokens';

import { APP_NAV_SPACES_DROPDOWN_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceStop } from '@confluence/experience-tracker/entry-points/component.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WarningContainer = styled.div({
	backgroundColor: token('color.background.warning'),
	padding: token('space.200'),
	textAlign: 'center',
});

const i18n = defineMessages({
	viewAll: {
		id: 'spaces-dropdown.view-all',
		defaultMessage: 'View all spaces',
		description: 'Text for link to space directory',
	},
	error: {
		id: 'spaces-dropdown.error',
		defaultMessage: 'We are unable to show your spaces at this time. Refresh or try again later.',
		description: 'Error message shown when the spaces dropdown fails to load',
	},
});
const experienceAttributes = {
	navVersion: '4',
};

export const SpacesDropdownError: FC<{ error: Error }> = ({ error }) => {
	return (
		<WarningContainer>
			<ExperienceStop
				name={APP_NAV_SPACES_DROPDOWN_EXPERIENCE}
				error={error}
				attributes={experienceAttributes}
			/>
			<FormattedMessage {...i18n.error} />
		</WarningContainer>
	);
};
